module.exports = __webpack_public_path__ + "img/input-data.3df0d13e.svg";